import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function EfficiencyEngagement() {
  return <section data-section-id="17307" id="start-your-project" className="dark bg-secondary text-foreground relative overflow-hidden py-24">
      {}
      <div className="absolute inset-0 bg-secondary z-0" />

      {}
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none">
        <svg className="h-full w-full" width="100%" height="100%" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="geometric-pattern" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
              <circle cx="2" cy="2" r="1" fill="currentColor" className="text-primary" />
              <circle cx="22" cy="22" r="1" fill="currentColor" className="text-primary" />
              <path d="M40 0 L0 40" stroke="currentColor" strokeWidth="0.5" className="text-primary" fill="none" />
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#geometric-pattern)" />
        </svg>
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-8 flex flex-col items-center text-center">
        <h2 className="text-4xl md:text-6xl font-semibold font-serif text-white mb-6 tracking-tight">
          Ready to Open Up Your Home?
        </h2>
        
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mb-10 leading-relaxed font-sans">
          Book a free consultation to see how BVP Group can transform your London property with bespoke kitchen renovations and bi-fold door installations.
        </p>

        <Link to="/ContactPage">
          <Button variant="ghost" size="lg" className="bg-primary border-none text-secondary text-xl font-bold px-10 py-7 h-auto rounded-sm transition-all duration-300 hover:bg-primary/90 hover:scale-105 shadow-xl">
            Book Free Consultation
            <ArrowRight className="ml-2 h-6 w-6" />
          </Button>
        </Link>
      </div>
    </section>;
}